import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Payyitme.module.css';
import { CheckSmall } from '../../icons';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const Header = () => (
  <header className={styles.hero}>
    <div className={`${styles.container} ${styles.heroGrid}`}>
      <div>
        <div className={`${styles.breadcrumb} ${styles.reveal} ${styles.d1}`}>
          <Link to="/">Fyntiq Business</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <span className={styles.breadcrumbCur}>Fyntiq.Me Lynk</span>
        </div>
        <h1 className={`${styles.reveal} ${styles.d2}`}>
          Your link.<br /><span className={styles.hl}>Their payment.</span>
        </h1>
        <p className={`${styles.heroSub} ${styles.reveal} ${styles.d3}`}>
          Create your Fyntiq.Me Lynk, share it anywhere, and start receiving money — from friends splitting a bill to customers paying your business.
        </p>
        <div className={`${styles.heroCta} ${styles.reveal} ${styles.d4}`}>
          <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Create your Lynk</Link>
          <a href="#how" className={styles.btnOutlineHero}>See how it works</a>
        </div>
        <div className={`${styles.heroNote} ${styles.reveal} ${styles.d5}`}>
          <span><CheckSmall />Free to create</span>
          <span><CheckSmall />Share anywhere</span>
          <span><CheckSmall />Secure checkout</span>
        </div>
      </div>

      <div className={`${styles.heroVisual} ${styles.reveal} ${styles.d3}`}>
        <div className={`${styles.floatChip} ${styles.fcCash}`}>
          <div className={`${styles.fcIc} ${styles.fcIcY}`}>
            <svg viewBox="0 0 24 24" width="18" fill="none" stroke="#161614" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10 13a5 5 0 0 0 7 0l2-2a5 5 0 0 0-7-7l-1 1" />
            </svg>
          </div>
          <div><div className={styles.fcLab}>Link copied</div><div className={styles.fcVal}>Ready</div></div>
        </div>
        <div className={`${styles.floatChip} ${styles.fcPayout}`}>
          <div className={`${styles.fcIc} ${styles.fcIcG}`}><CheckSmall /></div>
          <div><div className={styles.fcLab}>Payment</div><div className={styles.fcVal}>$48.00</div></div>
        </div>

        <div className={styles.payCard}>
          <div className={styles.pcTop}>
            <div className={styles.pcMerchant}>
              <div className={styles.pcLogo}>J</div>
              <div><div className={styles.pcMname}>Jordan Lee</div><div className={styles.pcMsub}>fyntiq.me/jordan</div></div>
            </div>
            <span className={styles.pcPaid}>● Live</span>
          </div>
          <div className={styles.pcAmtLab}>Send to Jordan</div>
          <div className={styles.pcAmt}>$48.00</div>
          <div className={styles.pcMethods}>
            <div className={`${styles.pcM} ${styles.pcMSel}`}>Wallet</div>
            <div className={styles.pcM}>Card</div>
            <div className={styles.pcM}>Bank</div>
          </div>
          <button type="button" className={styles.pcPay}>Pay $48.00 →</button>
        </div>
      </div>
    </div>
  </header>
);

export default Header;
